// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"9c47daf2","605":"975a1b04","691":"5d26837b","760":"b1526264"}[chunkId] + ".chunk.css";
};